import axios from "axios";
import { useQuery } from "react-query";
import { UserInfo } from "../types/userInfo";

const fetchUserInfo = async (key?: string): Promise<UserInfo> => {
  const { data } = await axios.get("/api/user-info", { params: { key } });
  return data;
};

// Função para limpar todos os dados de autenticação
const clearAuthData = () => {
  localStorage.removeItem("rh-user");
  localStorage.removeItem("rh-userName");
  localStorage.removeItem("rh-userId");
  localStorage.removeItem("rh-email");
  localStorage.removeItem("rh-key");
  localStorage.removeItem("rh-token");
  localStorage.removeItem("rh-refreshToken");
  localStorage.removeItem("rh-tokenExpire");
  localStorage.removeItem("rh-permissions");
  localStorage.removeItem("authkey");
};

export function useUserInfo(key?: string) {
  return useQuery(["user-info", key], () => fetchUserInfo(key), {
    enabled: !!key,
    retry: false, // Não tentar novamente em caso de erro
    onError: (error: any) => {
      // Se o erro for 401 (Unauthorized) ou similar, limpar dados de auth
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        console.warn(
          "Token inválido detectado, limpando dados de autenticação"
        );
        clearAuthData();
        // Forçar recarregamento da página para evitar loop
        window.location.replace("/login");
      }
    },
  });
}
